import { render, staticRenderFns } from "./ProductCreditBadge.vue?vue&type=template&id=0025533e&scoped=true&"
import script from "./ProductCreditBadge.vue?vue&type=script&lang=js&"
export * from "./ProductCreditBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreditBadge.vue?vue&type=style&index=0&id=0025533e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0025533e",
  null
  
)

export default component.exports